import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    buttonNo: 'No',
    buttonYes: 'Yes',
    continueCta: 'Continue',
    description: 'It should match the information on your ID',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    legalTitleLabel: 'Legal title',
    title: 'Who are you?',
  },
  fr: {
    buttonNo: 'Non',
    buttonYes: 'Oui',
    continueCta: 'Continuer',
    description:
      'Ces informations doivent être les mêmes que sur votre pièce d’identité.',
    firstNameLabel: 'Prénom',
    lastNameLabel: 'Nom',
    legalTitleLabel: 'Civilité',
    title: 'Qui êtes-vous\u00A0?',
  },
} as const);
